export default __webpack_public_path__ + "static/media/plus.82a82ca8.svg";